import { NgModule } from '@angular/core';
import {  DxDataGridModule,
          DxListModule,
          DxContextMenuModule,
          DxTemplateModule,
          DxButtonModule,
          DxToolbarModule,
          DxDrawerModule,
          DxTreeViewModule,
          DxTabPanelModule,
          DxNumberBoxModule,
          DxDropDownBoxModule,
          DxSelectBoxModule,
          DxTextAreaModule,
          DxBoxModule,
          DxSwitchModule,
          DxAccordionModule,
          DxTooltipModule,
          DxCheckBoxModule,
          DxTextBoxModule,
          DxValidatorModule,
          DxValidationGroupModule,
          DxPopupModule,
          DxScrollViewModule,
          DxTileViewModule,
          DxFileUploaderModule,
          DxColorBoxModule,
          DxDropDownButtonModule,
          DxResponsiveBoxModule,
          DxSliderModule,
          DxPieChartModule,
          DxChartModule,
          DxDateBoxModule,
          DxRadioGroupModule,
          DxTagBoxModule,
          DxAutocompleteModule,
          DxSchedulerModule,
          DxLinearGaugeModule,
          DxProgressBarModule
        } from 'devextreme-angular';
import { DxoEditingModule, DxoStateStoringModule } from 'devextreme-angular/ui/nested';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';

@NgModule({
  declarations: [
  ],
  imports: [
    DxContextMenuModule,
    DxTemplateModule,
    DxListModule,
    DxScrollViewModule,
    DxDataGridModule,
    DxButtonModule,
    DxCheckBoxModule,
    DxTextBoxModule,
    DxValidatorModule,
    DxValidationGroupModule,
    DxPopupModule,
    DxToolbarModule,
    DxDrawerModule,
    DxTreeViewModule,
    DxTabPanelModule,
    DxNumberBoxModule,
    DxDropDownBoxModule,
    DxDropDownButtonModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxBoxModule,
    DxTabPanelModule,
    DxSwitchModule,
    DxAccordionModule,
    DxTooltipModule,
    DxTileViewModule,
    DxFileUploaderModule,
    DxColorBoxModule,
    DxResponsiveBoxModule,
    DxSliderModule,
    DxPieChartModule,
    DxChartModule,
    DxDateBoxModule,
    DxRadioGroupModule,
    DxTagBoxModule,
    DxAutocompleteModule,
    DxoEditingModule,
    DxSchedulerModule,
    DxLinearGaugeModule,
    DxoStateStoringModule
  ],
  exports: [
    DxContextMenuModule,
    DxTemplateModule,
    DxListModule,
    DxScrollViewModule,
    DxDataGridModule,
    DxButtonModule,
    DxCheckBoxModule,
    DxTextBoxModule,
    DxValidatorModule,
    DxValidationGroupModule,
    DxPopupModule,
    DxToolbarModule,
    DxDrawerModule,
    DxTreeViewModule,
    DxTabPanelModule,
    DxNumberBoxModule,
    DxDropDownBoxModule,
    DxDropDownButtonModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxBoxModule,
    DxTabPanelModule,
    DxSwitchModule,
    DxAccordionModule,
    DxTooltipModule,
    DxTileViewModule,
    DxFileUploaderModule,
    DxColorBoxModule,
    DxResponsiveBoxModule,
    DxSliderModule,
    DxPieChartModule,
    DxChartModule,
    DxDateBoxModule,
    DxRadioGroupModule,
    DxTagBoxModule,
    DxAutocompleteModule,
    DxoEditingModule,
    DxSchedulerModule,
    DxLinearGaugeModule,
    DxProgressBarModule,
    DxoStateStoringModule
  ],
  providers: [
    DevExtremeTranslationService
  ],
  bootstrap: []
})
export class DxSharedModule { }
